import { useEffect } from "react";
import PageHeader from "../../pageheader/PageHeader";
import { useNavigate } from "react-router-dom";
import icon1 from "../../../asset/image/new/hla-b-58-1.svg";
import icon2 from "../../../asset/image/new/hla-b-57-1.svg";
import icon3 from "../../../asset/image/new/hla-b-15-1.svg";
import icon4 from "../../../asset/image/new/nat2-1.svg";
import icon5 from "../../../asset/image/new/pharma_icon5.svg";
import icon6 from "../../../asset/image/new/hla-a31-01-01.svg";
import icon7 from "../../../asset/image/new/hla-a13-01-01.svg";
import Breadcrumb from "../breacrumb/breadcrumb";

function PharmacogeneticTest({ role }) {
  const navigate = useNavigate();

  const pathItems = [
    { name: "หน้าหลัก", url: `${role ?? ""}/` },
    { name: "ข้อมูลที่เกี่ยวข้อง", url: `${role ?? ""}/information` },
    {
      name: "เภสัชพันธุศาสตร์",
      url: `${role ?? ""}/information/pharmacogeneticTest`,
    },
  ];

  const pharmaList = [
    {
      url: `${icon1}`,
      name: "HLA-B*58:01",
      title:
        "การตรวจ HLA-B*58:01 เพื่อหลีกเลี่ยงอาการผื่นแพ้ยา ที่เกิดจากการได้รับยา Allopurinol",
      link: "/information/pharmacogeneticTest/HLAB5801",
    },
    {
      url: `${icon2}`,
      name: "HLA-B*57:01",
      title:
        "การตรวจ HLA-B*57:01 เพื่อหลีกเลี่ยงอาการผื่นแพ้ยา ที่เกิดจากการได้รับยา Abacavir",
      link: "/information/pharmacogeneticTest/HLAB5701",
    },
    {
      url: `${icon3}`,
      name: "HLA-B*15:02",
      title:
        "การตรวจ HLA-B*15:02 เพื่อหลีกเลี่ยงอาการผื่นแพ้ยา ที่เกิดจากการได้รับยา Carbamazepine",
      link: "/information/pharmacogeneticTest/HLAB1502",
    },
    {
      url: `${icon4}`,
      name: "NAT2",
      title:
        "การตรวจ NAT2-Diplotype ตรวจยีนย่อยสลายยา Isoniacid เพื่อพิจารณาให้ยาในขนาด",
      link: "/information/pharmacogeneticTest/NAT2",
    },
    {
      url: `${icon5}`,
      name: "อาการไม่พึงประสงค์หลังจากการใช้ยา",
      title: "Stevens Johnson Syndrome (SJS) ผื่นแพ้ยาแบบรุนแรง",
      link: "/information/pharmacogeneticTest/ADRs",
    },
    {
      url: `${icon6}`,
      name: "HLA-A*31:01",
      title:
        "การตรวจ HLA-A*31:01 เพื่อหลีกเลี่ยงอาการผื่นแพ้ยา ที่เกิดจากการได้รับยา Carbamazepine",
      link: "/information/pharmacogeneticTest/HLAA3101",
    },
    {
      url: `${icon7}`,
      name: "HLA-B*13:01",
      title:
        "การตรวจ HLA-B*13:01 เพื่อหลีกเลี่ยงอาการผื่นแพ้ยา ที่เกิดจากการได้รับยา Dapsone",
      link: "/information/pharmacogeneticTest/HLAB1301",
    },
  ];

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="global-page">
      <Breadcrumb pathItems={pathItems} />
      {/* <h1 className="2sm:text-2xl flex w-full justify-start py-5 text-3xl font-bold">
          เภสัชพันธุศาสตร์
        </h1> */}

      <PageHeader titlename={"เภสัชพันธุศาสตร์"} />

      <div className="2lg:grid-cols-1 grid grid-flow-dense grid-cols-2 gap-8 w-full">
        {pharmaList.map((pharma, index) => (
          <div
            className="xsm:flex-col xsm:items-center flex flex-row gap-4 cursor-pointer"
            onClick={() => navigate(pharma.link)}
          >
            <div className="xl:max-h-36 xl:max-w-36 overflow-hidden min-w-36 w-[30%] aspect-square p-5 justify-items-center align-middle bg-white rounded-lg border border-gray-400">
              <img
                className="object-scale-down h-full"
                src={pharma.url}
                alt={`รูปประกอบของ ${pharma.title}`}
              />
            </div>
            <div className="flex flex-col gap-1 w-[100%] py-2">
              <span className="2sm:text-lg text-xl font-bold">
                {pharma.name}
              </span>
              <span>{pharma.title}</span>
              <span className="text-blue-800">อ่านเพิ่มเติม</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default PharmacogeneticTest;
